import { DragEndEvent, DragOverEvent, DragStartEvent } from '@dnd-kit/core';

type Handler = {
  onDragStart?: (event: DragStartEvent) => void;
  onDragOver?: (event: DragOverEvent) => void;
  onDragEnd?: (event: DragEndEvent) => void;
};

const handlers: Record<string, Handler> = {};

export const CentralDragAndDropStore = {
  get: () => handlers,
  register: ({ type, handler }: { type: string; handler: Handler }) => {
    handlers[type] = handler;
  },
};
